import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Chart from "chart.js/auto";
import CustomAlert from "../CustomAlert";

export default function Statistics() {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalProducts: 0,
    totalAccessories: 0,
    chartData: []
  });
  const [alertMsg, setAlertMsg] = useState({ type: "", message: "" });
  const chartRef = useRef(null);
  const API_BASE = "https://laravel-api.aj-mart.com/api";
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  useEffect(() => {
    // Fetch dashboard stats from API
    axios.get(`${API_BASE}/dashboard`)
      .then(response => {
        if (response.data.status) {
          setStats(response.data.data);
        } else {
          setAlertMsg({ type: "error", message: "Failed to fetch dashboard stats" });
        }
      })
      .catch(error => {
        console.error("Error fetching stats:", error);
        setAlertMsg({ type: "error", message: "Error fetching dashboard stats" });
      });
  }, []);

  useEffect(() => {
    if (stats.chartData.length > 0 && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      // Prepare labels and data from API
      const labels = stats.chartData.map(item => `Month ${item.month}`);
      const data = stats.chartData.map(item => item.count);
      
      // Create the chart
      new Chart(ctx, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Orders",
              data,
              backgroundColor: "rgba(0, 123, 255, 0.5)",
              borderColor: "rgba(0, 123, 255, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    }
  }, [stats.chartData]);

  return (
    <section className="py-[25px]">
      <div className="main-title mb-[20px]">Statistics</div>
      {alertMsg.message && (
        <CustomAlert 
          type={alertMsg.type} 
          message={alertMsg.message} 
          onClose={() => setAlertMsg({ type: "", message: "" })}
        />
      )}
      <div className="overflow-x-auto">
        <div className="bg-gray-100 p-8 rounded-md shadow-md">
          <div className="flex flex-wrap items-center gap-6 mb-8">
            <div className="p-4 w-[23%] bg-white border rounded-md shadow flex items-center justify-between">
              <div>
                <span className="capitalize text-sm text-gray-600">Total Orders</span>
                <h1 className="text-xl font-bold">{stats.totalOrders}</h1>
              </div>
              <img 
                src={require("../../assets/images/stats.png")} 
                alt="Total Orders" 
                className="w-12 h-12" 
              />
            </div>
            <div className="p-4 w-[23%] bg-white border rounded-md shadow flex items-center justify-between">
              <div>
                <span className="capitalize text-sm text-gray-600">Total Products</span>
                <h1 className="text-xl font-bold">{stats.totalProducts}</h1>
              </div>
              <img 
                src={require("../../assets/images/stats.png")} 
                alt="Total Products" 
                className="w-12 h-12" 
              />
            </div>
            <div className="p-4 w-[23%] bg-white border rounded-md shadow flex items-center justify-between">
              <div>
                <span className="capitalize text-sm text-gray-600">Total Accessories</span>
                <h1 className="text-xl font-bold">{stats.totalAccessories}</h1>
              </div>
              <img 
                src={require("../../assets/images/stats.png")} 
                alt="Total Accessories" 
                className="w-12 h-12" 
              />
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="bg-white p-4 rounded-md shadow">
              <canvas ref={chartRef} id="chart1"></canvas>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
